module.exports = __webpack_public_path__ + "media/Video (6).0690a386.mp4";